<div class="container-fluid">
  <!-- Header-->
  <header>
    <div class="row ey-header-container">
      <div class="col-sm-12">
        <h1 class="ey-header">TP Benchmark Terms of Use</h1>
      </div>
    </div>
  </header>
  <!-- Header-->

  <!--Content-->
  <div class="ey-content mt-3">
    <div class="col-sm-12">
      <p class="text-danger">You must acknowledge the TP Benchmark Terms of Use to use the application.</p>
    </div>
  </div>
  <!--Content-->
</div>
